// src/locale/en/HomePage.ts - Corrected version
export default {
  logoAlt: 'Logo',
  personalPlanTitle: 'Your Personal Lifestyle Plan - Just For You!',
  bwellDescription: 'Bwell helps you determine how you want your physical, mental and social life to feel good, both at work and in life.',
  privacyNotice: 'NOTE! Only you can see your results.',
  clickToStartWork: 'Click now on box 1 <strong>My work</strong> and let\'s go!',
  clickToStartSchool: 'Click now on box 1 <strong>My schooling</strong> and let\'s go!',
  denyMessage: 'Trying to cheat huh?<br/>Finish level 1 and 2 first!',
  angryMonsterAlt: 'Angry Monster',
  myWork: 'My work',
  mySchool: 'My schooling',
  myLifestyle: 'My lifestyle',
  myGoals: 'My goals',
  myLifestylePlan: 'My lifestyle plan'
};

// src/locale/sv/HomePage.ts - Corrected version
